import React, { useState, useEffect } from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const CollectionLetters = (props) => {
  const [letters, setLetters] = useState([
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ]);

  const LetterClick = (letter) => {
    props.LetterClick(letter);
  };

  return (
    <div>
      {typeof letters != "undefined" &&
        letters.map((se) => (
          <MenuItem onClick={()=>LetterClick(se)} value={se}>
            {se}
          </MenuItem>
        ))}
    </div>
  );
};

export default CollectionLetters;
